module.exports = __webpack_public_path__ + "img/img1.6663ae6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img1.jpg
// module id = 305
// module chunks = 0